export default "__VITE_ASSET__B5zM30FO__"